<template>
  <div id="app">
    <progress-bar></progress-bar>
    <alert></alert>
    <router-view></router-view>
    <tooltip></tooltip>
  </div>
</template>

<script>
  import Alert from '@/components/alert'
  import ProgressBar from '@/components/progress_bar'

  export default {
    name: 'app',

    components: {
      Alert,
      ProgressBar
    }
  }
</script>

<style lang="scss" global>
  @import "~@/style/global";
</style>



// WEBPACK FOOTER //
// src/App.vue